// extracted by mini-css-extract-plugin
module.exports = {"scrollableContainer":"hardware-list_scrollableContainer_MnmhQ"};